import { IMask } from 'react-imask';

export const formattedNumberMask: IMask.AnyMaskedOptions = {
  mask: Number,
  scale: 0,
  signed: false,
  thousandsSeparator: ',',
};

export const phoneMask: IMask.AnyMaskedOptions = {
  mask: '(000) 000-0000',
  lazy: true,
};
